import Markdown from "markdown-to-jsx";
import { useEffect } from "react";

export default function ReferMarkdownRenderer(props: { setReady: (option: boolean) => void }) {
  const { setReady } = props;
  const content = `

**Date: 31 May 2024**

_This Caleb & Brown Refer A Friend Terms and Conditions should be read in conjunction with Caleb and Brown Pty Ltd’s Terms of Business ([www.calebandbrown.com/terms-of-business](http://www.calebandbrown.com/terms-of-business)) and Privacy Policy ([www.calebandbrown.com/privacy-policy](http://www.calebandbrown.com/privacy-policy))._

1. **Caleb & Brown Refer A Friend Terms and Conditions**

   **a)**  These terms and conditions (the “**T&Cs**”) apply to the Caleb & Brown Refer A Friend Program (the “**Promotion**”). By participating in the Promotion, you agree to be bound by these T&Cs.
   
   **b)** This Promotion is run by Caleb and Brown Pty Ltd (ACN 619 023 559) (“**Caleb & Brown**”, “**We**”, “**Our**”, or “**Us**”).

2. **Eligibility**

   To be eligible for the Promotion, the person making the referral (“**You**”, “**Your**”) must have successfully registered with Caleb & Brown and maintain a valid, verified account with Us.

3. **Prospective Client**

   **a)** The person (whether individual or non-individual) You would like to refer (“**Prospective Client**”) must:

      i). be a person who is not an existing client of Caleb & Brown at the time of the referral;

      ii). not have previously been a client of Caleb & Brown, unless otherwise permitted in Caleb & Brown’s absolute discretion; and
      
      iii). have an existing personal relationship with You.

4. **Participating in the Promotion (“Referral Efforts”)**

   **a)** You may from time to time refer Prospective Clients to Us. However, You are not an agent of Caleb & Brown and are not permitted to bind Caleb & Brown to any agreement, arrangement, understanding or obligation. Rather, You warrant that you are voluntarily referring prospective clients because you have used our services and are satisfied with it.

   **b)**. You should make your Prospective Clients aware that you will be entitled to receive Referral Rewards calculated based on their completed trades, per clauses 5(a)-(b).

   **c)** Nothing in this Agreement authorises You to provide any _financial service_ as the term is defined in the _Corporations Act 2001_ (Cth) or any similar or analogous services in jurisdictions other than Australia the provision or promotion of which requires a person to hold certain authorisations, permissions or licences (“**Financial Services**”), whether on its own behalf or on behalf of Caleb & Brown.

   **c)** In order to participate in the Promotion, You must share the unique URL provided to you as part of this Promotion (“**Referral Link**”) with Prospective Client(s) and the Prospective Client(s) must have successfully opened a Caleb & Brown account with Us using your Referral Link.

   **e)** All Caleb & Brown accounts are subject to our standard account opening requirements. As such, not all Prospective Clients You refer to Us will be successful in their application to open a Caleb & Brown account. Those who are successful in their application are referred to as “**Referred Client**”.

5. **Earning Referral Rewards**

   **a)** In consideration for Your Referral Efforts, and subject to these T&Cs, You are entitled to receive a reward in USDC or any type of currency at Our discretion (“**Referral Reward**”) upon each Referred Client’s successfully completed trades (purchase, sales or swap) done through Caleb & Brown.

   **b)** The Referral Reward will be calculated by reference to the percentage specified in the appended Schedule A.

   **c)** The Referral Reward will be credited to Your Caleb & Brown account (the **“Account**”).

   **d)** Caleb & Brown will pay the Referral Reward into Your Account by the 7th day of the month following the month in which the Referral Reward was generated.

   **e)** You will be informed through the Caleb & Brown Portal (“**Portal**”) when the Referral Reward is credited to your Account. The Referral Reward will be denoted as such within the Transactions and Refer A Friend pages of the Portal.
   
   **f)** You may use the Referral Reward in the same manner as any other token held in Your Account, subject to Caleb & Brown's Terms of Business.

   **g)** No Referral Reward is payable:
      
   i) in respect of a Referred Client (actual or purported) where Caleb & Brown, acting reasonably and following an investigation, considers that:
      
      (1) You did not refer that person to Caleb & Brown;

      (2) the Referred Client was not a Prospective Client at the time of referral; or
   
   ii) to the extent that Caleb & Brown considers, acting reasonably and following an investigation, that:

      1. the Referral Reward does not relate to, or was generated other than due to, a genuine Prospective Client accessing Caleb & Brown’s products and services via links published by You or signing up to and/or acquiring or using Caleb & Brown’s brokerage products or services; or

      1. the Referral Reward was generated due to transactions where churning occurred; and

the rights of Caleb & Brown under this clause are in addition to any other rights and remedies available to Caleb & Brown.

6. **General**

   **a)** The Referral Reward is non-transferable and non-assignable. You must not assign, transfer, mortgage, charge or deal in any other manner with any or all of its rights and obligations under the T&Cs without Caleb & Brown’s prior written consent which must not be unreasonably withheld.

   **b)** You will be solely responsible for all costs and expenses including taxes that may be incurred by You in connection with the Promotion. You should seek professional taxation and/or legal advice at Your own cost if necessary to understand your potential liability.

   **c)** This Promotion cannot be combined with any other reward promotions that Caleb & Brown offers (such as the Caleb & Brown Referral Partner program).

   **d)** You are prohibited from spamming the Referral Link or Referral Code. This includes mass emailing, texting, or messaging people you do not know or using automated systems or bots through any channel to distribute your Referral Link or Referral Code. Caleb & Brown reserves the right to disable a Referral Link or Referral Code, terminate Your participation in the Promotion and/or accept any other appropriate measures to protect the Promotion and Caleb & Brown itself from any client who misuses the Promotion.

   **e)** Caleb & Brown reserves the right to revoke or withdraw the Promotion and any of Our obligations in relation to the Promotion from participants who unfairly exploit or violate the purpose and the T&Cs of the Promotion. For example, a holder of multiple Accounts referring their own accounts to earn a Referral Reward on their own trades.

   **f)** Per our Privacy Policy, we may from time to time collect, use, and hold some types of personal information and non-personal information to meet our legal obligations and to provide our services to You. These may include but are not limited to transactional information, personal and contact details, interaction information with us, etc.

7. **Severability**

   If any provision in these T&Cs is held to be invalid, void, or unenforceable, such provision (or the part of it that is making in invalid, void or unenforceable) will be struck and not affect the validity and enforceability of the remaining provisions.

8. **Update to the T&Cs**
   
   **a)** We reserve the right to update, change, modify, add, pause, remove or discontinue portions or the entirety of these T&Cs where reasonably required. We will display a notification on Portal indicating when any such revisions have been made. Subject to clause 8(b), any revisions or modifications to these T&Cs published on the Portal will be taken to be effective thirty (30) days after publication. Your subsequent or continued participation in the Promotion after such revision or modification of these T&Cs shall constitute your acceptance of these changes and subject Your Account to the modified T&Cs. If you do not agree to the revision or modification, you may terminate being a participant of the Promotion.

   **b)** We may update, change, modify, add, pause, remove or discontinue portions of the entirety of these T&Cs with immediate effect where required to do so in order to comply with applicable laws. We will display a notification on Portal indicating when any such revisions have been made. Your subsequent or continued participation in the Promotion after such revision or modification of these T&Cs shall constitute your acceptance of these changes and subject Your Account to the modified T&Cs. If you do not agree to the revision or modification, you may terminate being a participant of the Promotion.

9. **Termination**

   **a)** Caleb & Brown may terminate Your participation in the Promotion:
      
      i) immediately upon providing written notice to You, if:

      1. You are a natural person and die;
      2. You or Caleb & Brown suffer an Event of Insolvency;
      3. You have breached this T&Cs and fails to remedy that breach within fourteen (14) days of receipt of written notice from Caleb & Brown requiring it to remedy that breach;
      4. You have breached this T&Cs and the breach is in the reasonable opinion of Caleb & Brown, incapable of remedy;
      5. You have breached this T&Cs multiple times, notwithstanding that You may have remedied the same;
      6. You have breached an applicable law or has by its act or omission, caused Caleb & Brown to or in Caleb & Brown’s opinion (acting reasonably) created a high likelihood that Caleb & Brown will breach an applicable law;
      7. any part of the T&Cs is contrary to an applicable law;
      8. Caleb & Brown considers, acting reasonably, that an act or omission of the committed by You has or is likely to cause damage to Caleb & Brown’s reputation;
      9. You are subject to a change in control which Caleb & Brown considers, acting reasonably, may compromise Caleb & Brown’s reputation or Caleb & Brown’s ability to comply with all applicable laws;
      10. the Account is closed by either Caleb & Brown or You; or

      ii) for no cause, by giving You thirty (30) days’ written notice.

      iii) After termination, Your right to the Referral Reward ceases, with effect on and from the date of the termination.

   **b)** Termination of Your participation in the Promotion does not affect any rights and liabilities which have accrued up to the date of termination.

10. **Governing Law**

These T&Cs are governed by the laws of the State of Victoria.

**Schedule A - Reward Tiers**

Unless otherwise stated, all amounts stated below are in the default currency of Your Account.

1. **Bronze Tier**

   **a)** You will receive 2% of the fee that Caleb & Brown receives from each trade that the Referred Client successfully completes. For example, if the Referred Client pays $100 in fees to Us, You will receive $2.

   **b)** This is the default tier.

2. **Silver Tier**

   **a)** You will receive 3% of the fee that Caleb & Brown receives from each trade that the Referred Client successfully completes. For example, if the Referred Client pays $100 in fees to Us, You will receive $3.

   **b)** You qualify for this tier upon successfully referring 5 Referred Clients that trade (“**Trading Clients**”).

   **c)** Your admission into this tier will happen at the beginning of the new month when rewards are calculated. Your rewards will not be retrospective, and will only count from that day forward.

   **d)** Alternatively, we may, in Our absolute discretion, opt to promote you to this tier without You meeting the above criteria.

3. **Gold Tier**

   **a)** You will receive 4% of the fee that Caleb & Brown receives from each trade that the Referred Client successfully completes. For example, if the Referred Client pays $100 in fees to Us, You will receive $4.

   **b)** You qualify for this tier upon successfully referring 15 Trading Clients.

   **c)** Your admission into this tier will happen at the beginning of the new month when rewards are calculated. Your rewards will not be retrospective, and will only count from that day forward.

4. **Black Tier**

   **a)** You will receive 5% of the fee that Caleb & Brown receives from each trade that the Referred Client successfully completes. For example, if the Referred Client pays $100 in fees to Us, You will receive $5.
   
   **b)** You qualify for this tier upon successfully referring 25 Trading Clients.

   **c)** Your admission into this tier will happen at the beginning of the new month when rewards are calculated. Your rewards will not be retrospective, and will only count from that day forward.
`;

  useEffect(() => {
    setReady(true);
  }, []);

  return <Markdown children={content} />;
}
